import React, { useContext } from "react";
import "./styles/ReleasedItemProject.scss";
import TypeIconReturner from "../../../components/TypeIconReturner/TypeIconReturner";
import AppContext from "../../../context/appContext";

const ReleasedItemProject = (props) => {
  const { project } = props;

  const {
    type,
    title,
    creators = [],
    format,
    soapOperaSchedule,
    lastTextReleaseDate,
    attachmentReleasedCount,
  } = project;

  const appContext = useContext(AppContext);

  const toggleListReleaseActivity = (ev) => {
    let targetActive = ev.target.closest(
      ".contentListAttachmentsReleased"
    );

    if (targetActive) {
      targetActive.classList.toggle("active");
    }
  };

  return (
    <div
      className="releasedItemProject"
      onClick={(e) => toggleListReleaseActivity(e)}
    >
      <div className="containerTitleAndCreators">
        <div className="contentTitle">
          <TypeIconReturner type={type} responsiveIcon />

          <span className="title">{`${title} (${attachmentReleasedCount})`}</span>
        </div>

        <div className="creatorsReleased">
          {!!creators.length &&
            creators.map((creator, i) => {
              return (
                <div key={i}>
                  <span>{creator.name}</span>

                  {i + 1 < creators.length && (
                    <span className="creatorSeparator">
                      |
                    </span>
                  )}
                </div>
              );
            })}
        </div>
      </div>

      <div className="formatReleased">
        {format?.name}

        {format?.name === "Novela"
          ? soapOperaSchedule
          : ""}
      </div>

      <span className="lastAttachment">
        {!!lastTextReleaseDate &&
          "Liberado em "}

        <span className="date">
          {!!lastTextReleaseDate &&
            appContext.formatDate(
              appContext.convertDatePtBr(
                lastTextReleaseDate
              )
            )}
        </span>
      </span>
    </div>
  );
};

export default ReleasedItemProject;